import { Controller } from "@hotwired/stimulus"

// Unified dynamic list controller for objectives, contact roles, data extraction keys, etc.
export default class extends Controller {
  static targets = ["container", "template", "item"]
  static values = {
    sortable: { type: Boolean, default: false }
  }

  connect() {
    // Focus on the first empty input if it exists
  }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget.innerHTML
    this.containerTarget.insertAdjacentHTML("beforeend", template)
    
    // Focus the first input in the new item
    const newItem = this.containerTarget.lastElementChild
    const firstInput = newItem.querySelector("input, textarea")
    if (firstInput) {
      firstInput.focus()
    }
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-dynamic-list-target='item']")
    if (item) {
      item.remove()
    }
  }

  moveUp(event) {
    event.preventDefault()
    const item = event.target.closest("[data-dynamic-list-target='item']")
    if (item && item.previousElementSibling) {
      item.parentNode.insertBefore(item, item.previousElementSibling)
    }
  }

  moveDown(event) {
    event.preventDefault()
    const item = event.target.closest("[data-dynamic-list-target='item']")
    if (item && item.nextElementSibling) {
      item.parentNode.insertBefore(item.nextElementSibling, item)
    }
  }
}
